import { Calendar } from "antd";
import Timer from "helpers/timer";
import moment from "moment";
import React, { useRef, useState } from "react";
import "./styles.less";

const CalendarUsagePlanRender = (props) => {
  const {
    onSelect = () => { },
    onChangeCalendar = () => { },
    disablePopover = false,
    dateCellRender = () => {},
  } = props;
  
  //! State
  const timer = useRef(new Timer());
  const [isChangeMonth, setIsChangeMonth] = useState(true);

  //! Effect
  
  //! Function
  const onPanelChange = (e) => {
    // Anti open Popover when Calender change Month (Error Cell)
    setIsChangeMonth(false);
    if(onChangeCalendar) {
      const newDateRange = {fullValue : [moment(e).startOf('month'), moment(e).endOf('month')]};
      onChangeCalendar(newDateRange);
    }
    timer.current.debounce(() => {setIsChangeMonth(true)}, 200);
  };

  const validRange = () => {
    return [moment().add(-5, "year"), moment().add(5, "year")];
  };

  //! Render
  return (
    <div className={`calendar-custom-plan`}>
      <Calendar
        validRange={validRange()}
        onSelect={onSelect}
        onPanelChange={onPanelChange}
        dateFullCellRender={dateCellRender}
      />
    </div>
  );
};

export default CalendarUsagePlanRender;
